var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { useContactingTestId, useCustomerAction } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { useContactContext, usePlatoAvailable, useProviderSection, } from "@/contexts/contact";
import { BookVisitButton, PhoneButton } from "@/components/contacting/Buttons";
import { NoPhoneInfo } from "@/components/contacting/ProviderSection/NoPhoneInfo";
import { IS_SERVER } from "@/constants";
import { useCallTracking, useCallTrackingPhoneNumbers, } from "@/contexts/callTracking";
import { EnvelopeIcon } from "@gemini/icons";
import { useState } from "react";
import { PhoneItem } from "../PhoneContactInfos/PhoneBlock";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
const ContactButton = (_a) => {
    var { onPress } = _a, props = __rest(_a, ["onPress"]);
    const { customerActionExposeInteraction } = useCustomerAction();
    const isPreviewMode = useIsPreviewMode();
    const handlePress = () => __awaiter(void 0, void 0, void 0, function* () {
        yield customerActionExposeInteraction([
            { key: "interaction", value: "openContactForm" },
        ]);
        onPress();
    });
    const testId = useContactingTestId("ProviderSection.ContactCard.ContactButton");
    return (_jsx(Button, Object.assign({}, props, { onPress: handlePress, variant: "primary", iconOnly: true, size: "40", icon: EnvelopeIcon, testId: testId, isDisabled: isPreviewMode, children: "contact" })));
};
const Phone = ({ phoneNumbers, testId, }) => {
    const [showPhoneNumbers, setShowPhoneNumbers] = useState(false);
    const { customerActionExposeContactPhoneCall } = useCustomerAction();
    const { isCallTrackingRequestDone } = useCallTracking();
    const virtualPhoneNumbers = useCallTrackingPhoneNumbers();
    const displayedPhoneNumbers = virtualPhoneNumbers !== null && virtualPhoneNumbers !== void 0 ? virtualPhoneNumbers : phoneNumbers;
    const isPreviewMode = useIsPreviewMode();
    const handleShowPhoneNumbers = () => {
        if (isPreviewMode)
            return;
        setShowPhoneNumbers(true);
    };
    const onPressPhoneCall = (phoneNumber) => __awaiter(void 0, void 0, void 0, function* () {
        if (IS_SERVER || !phoneNumber || isPreviewMode)
            return;
        yield customerActionExposeContactPhoneCall();
        // eslint-disable-next-line no-restricted-globals
        window.location.href = `tel:${phoneNumber.replace(/\s/g, "")}`;
    });
    return (_jsx(_Fragment, { children: !showPhoneNumbers || !isCallTrackingRequestDone ? (_jsx(PhoneButton, { trackingAvZone: "detail_agency_block", legacyTrackingInfos: "detail-bottom", rootTestId: testId, iconOnly: true, onPress: handleShowPhoneNumbers, displayPhoneNumbers: true, children: "Tel" })) : (_jsx(Box, { display: "flex", gap: "spacing.12", flexDirection: "column", children: displayedPhoneNumbers.map((phoneNumber, index) => (_jsx(Box, { as: "div", onClick: () => onPressPhoneCall(phoneNumber), pointerEvents: isPreviewMode ? "none" : "auto", children: _jsx(PhoneItem, { index: index, phoneNumber: phoneNumber, testId: testId }, phoneNumber) }, phoneNumber))) })) }));
};
export const ContactCtas = ({ testId }) => {
    var _a;
    const { t } = useI18n();
    const providerSection = useProviderSection();
    const { toggleModal } = useContactContext();
    const isPreviewMode = useIsPreviewMode();
    const isPlatoAvailable = usePlatoAvailable();
    const handlePress = () => {
        if (isPreviewMode)
            return;
        toggleModal({
            av_zone: "detail_agency_block",
            legacyTrackingInfos: "detail-bottom", //tracking GA3 for harvest
        });
    };
    return (_jsxs(Box, { gap: "spacing.16", alignItems: "center", marginLeft: "spacing.24", display: {
            "breakpoint.base": "none",
            "breakpoint.sm": "flex",
        }, children: [((_a = providerSection === null || providerSection === void 0 ? void 0 : providerSection.phoneNumbers) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_jsx(Phone
            // @ts-ignore
            , { 
                // @ts-ignore
                phoneNumbers: providerSection.phoneNumbers, testId: testId })) : (_jsx(NoPhoneInfo, { testId: `${testId}.Nophone` })), isPlatoAvailable && (_jsx(BookVisitButton, { av_zone: "detail_agency_block", rootTestId: testId, iconOnly: true, children: t("contact.cta.book_visit") })), _jsx(ContactButton, { onPress: handlePress })] }));
};
